import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Dispute() {
  return (
    <LegalPage
      title="Dispute & Chargeback Policy"
      eyebrow="DISPUTES"
      lastUpdated="January 2026"
    >
      <p>
        We want every customer of <strong>Tapped In Clarity</strong> to feel
        heard. Please read this policy before raising a chargeback with your
        bank or card provider — most issues can be resolved more quickly and
        fairly by contacting us first.
      </p>

      <h2>1. Talk To Us First</h2>
      <p>
        If you are unhappy with anything you have purchased — the Albetheine
        Oracle app, the online Guidebook, a psychic medium reading or a
        physical oracle deck — please email{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>{" "}
        with:
      </p>
      <ul>
        <li>Your order or booking reference.</li>
        <li>The date of purchase.</li>
        <li>A clear description of the issue.</li>
        <li>Any supporting photos or screenshots.</li>
      </ul>
      <p>
        We aim to respond within <strong>3 working days</strong> and to resolve
        the matter within <strong>14 days</strong> of receiving all the
        information we need.
      </p>

      <h2>2. Our Resolution Process</h2>
      <ol>
        <li>
          We review your account, the order details and our records of the
          delivery or session.
        </li>
        <li>
          Where appropriate, we will offer a remedy in line with our{" "}
          <a href="/refund">Refund Policy</a> — for example a replacement
          physical deck, a reschedule, a credit, or a partial or full refund.
        </li>
        <li>
          If you are not satisfied with our proposed remedy, you may escalate
          the matter as described below.
        </li>
      </ol>

      <h2>3. Chargebacks</h2>
      <p>
        A chargeback is a request you make to your bank or card provider to
        reverse a payment. We treat chargebacks as a last resort and ask that
        you contact us first so we can put things right.
      </p>
      <p>
        When a chargeback is raised:
      </p>
      <ul>
        <li>
          We will be informed by our payment processor (Stripe) and will be
          asked to respond with evidence within a short deadline.
        </li>
        <li>
          We will submit relevant evidence including: proof of purchase, terms
          you accepted at checkout, delivery or access records, communication
          history and our applicable policies.
        </li>
        <li>
          Where a chargeback is raised for a digital product that has already
          been accessed, or for a psychic reading that has already been
          delivered, we will defend the chargeback in full, as such items are
          non-refundable under our published <a href="/refund">Refund Policy</a>.
        </li>
        <li>
          Fraudulent or abusive chargebacks may result in suspension or
          termination of your account and may be referred for legal recovery.
        </li>
      </ul>

      <h2>4. Fraud Protection</h2>
      <p>
        All payments are processed by <strong>Stripe</strong>, which performs
        fraud screening. If a transaction is flagged as suspicious we may
        cancel the order and refund the original payment.
      </p>

      <h2>5. Alternative Dispute Resolution</h2>
      <p>
        If we cannot resolve a dispute between us, you may be entitled to use
        an alternative dispute resolution provider. Please contact us first so
        we can attempt to resolve the matter directly.
      </p>

      <h2>6. Your Statutory Rights</h2>
      <p>
        This policy does not affect any of your statutory rights under UK
        consumer law, including the Consumer Rights Act 2015.
      </p>

      <h2>7. Contact</h2>
      <p>
        All disputes:{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
